<template>
  <div style="margin: 10px">
    <v-card :id="searchDiv">
      <v-toolbar color="primary" dark v-if="displayToolbar">
        <v-toolbar-title>{{ $t(formName) }}</v-toolbar-title>
        <v-spacer/>
        <slot name="featureBtn">

        </slot>
        <v-tooltip bottom v-for="(item, key) in buttons " :key=key>
          <template v-slot:activator="{ on }">
            <v-btn
                @click="onButtonEvent(item.event)"
                class="elevation-1"
                :color="item.color"
                dark
                fab
                small
                v-on="on"
            >
              <v-icon>{{ item.icon }}</v-icon>
            </v-btn>
          </template>
          <span>{{ item.text }}</span>
        </v-tooltip>
        <v-tooltip bottom>
<!--          <template v-slot:activator="{ on }">
            <v-btn
                v-if="formType=='intable'"
                fab
                dark
                small
                @click="onSearch()"
                color="blue-grey"
                class="elevation-1"
                v-on="on"
            >
              <v-icon>search</v-icon>
            </v-btn>
          </template>
          <span>Search</span>-->
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
                v-if="acceptCreate == true && formType=='intable'"
                fab
                dark
                small
                @click="createNew()"
                color="light-blue"
                class="elevation-1"
                v-on="on"
            >
              <v-icon>add</v-icon>
            </v-btn>
          </template>
          <span>Add</span>
        </v-tooltip>
        <v-btn color="blue" @click="createNew()" v-if="acceptCreate2 == true && formType=='intable'">
          Thêm mới
        </v-btn>

        <template v-if="deleteMulti==true">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                  v-if="acceptDelete == true && formType=='intable'"
                  color="error"
                  fab
                  dark
                  small
                  @click="deleteItemList()"
                  @click.stop="confirmDelete = true"
                  class="elevation-1"
                  v-on="on"
              >
                <v-icon>delete</v-icon>
              </v-btn>
            </template>
            <span>Delete</span>
          </v-tooltip>
        </template>
        <v-btn color="blue" @click="onExport()" v-if="acceptExport == '1' ">
          {{ $t("Export") }}
        </v-btn>
        <v-btn color="blue" @click="onExport()" v-if="acceptExport == '2' ">
          {{ $t("Export") }}
        </v-btn>
        <v-btn color="blue" @click="onExport()" v-if="acceptExport == '3' ">
          {{ $t("Export") }}
        </v-btn>
        <v-btn color="blue" @click="onExport()" v-if="acceptExport == '4' ">
          {{ $t("Export") }}
        </v-btn>
        <v-btn color="blue" @click="onExport()" v-if="acceptExport == '5' ">
          {{ $t("Export") }}
        </v-btn>
        <v-btn color="blue" @click="onExport()" v-if="acceptExport == '6' ">
          {{ $t("Export") }}
        </v-btn>
        <v-btn color="blue" @click="onExport()" v-if="acceptExport == '7' ">
          {{ $t("Export") }}
        </v-btn>
        <v-btn color="blue" @click="onExport()" v-if="acceptExport == '8' ">
          {{ $t("Export") }}
        </v-btn>
        <v-btn color="blue" @click="onExport()" v-if="acceptExport == '9' ">
          {{ $t("Export") }}
        </v-btn>
        <v-btn color="blue" @click="onExport()" v-if="acceptExport == '10' ">
          {{ $t("Export") }}
        </v-btn>
        <v-btn color="blue" @click="onExport()" v-if="acceptExport == '11' ">
          {{ $t("Export") }}
        </v-btn>
        <v-btn color="grey" @click="onCancel1" v-if="acceptBack == '1'">
          {{ $t("lang.common.back") }}
        </v-btn>
        <v-btn color="grey" @click="onCancel1001" v-if="acceptBack == '1001'">
          {{ $t("lang.common.back") }}
        </v-btn>
        <v-btn color="grey" @click="onCancel2" v-if="acceptBack == '2'">
          {{ $t("lang.common.back") }}
        </v-btn>
        <v-btn color="grey" @click="onCancel2001" v-if="acceptBack == '2001'">
          {{ $t("lang.common.back") }}
        </v-btn>
        <v-btn color="grey" @click="onCancel3" v-if="acceptBack == '3'">
          {{ $t("lang.common.back") }}
        </v-btn>
        <v-btn color="grey" @click="onCancel3001" v-if="acceptBack == '3001'">
          {{ $t("lang.common.back") }}
        </v-btn>
        <v-btn color="grey" @click="onCancel4" v-if="acceptBack == '4'">
          {{ $t("lang.common.back") }}
        </v-btn>
        <v-btn color="grey" @click="onCancel4001" v-if="acceptBack == '4001'">
          {{ $t("lang.common.back") }}
        </v-btn>
        <v-btn color="grey" @click="onCancel5" v-if="acceptBack == '5'">
          {{ $t("lang.common.back") }}
        </v-btn>
        <v-btn color="grey" @click="onCancel5001" v-if="acceptBack == '5001'">
          {{ $t("lang.common.back") }}
        </v-btn>
        <v-btn color="grey" @click="onCancel6" v-if="acceptBack == '6'">
          {{ $t("lang.common.back") }}
        </v-btn>
        <v-btn color="grey" @click="onCancel6001" v-if="acceptBack == '6001'">
          {{ $t("lang.common.back") }}
        </v-btn>
        <v-btn color="grey" @click="onCancel7" v-if="acceptBack == '7'">
          {{ $t("lang.common.back") }}
        </v-btn>
        <v-btn color="grey" @click="onCancel7001" v-if="acceptBack == '7001'">
          {{ $t("lang.common.back") }}
        </v-btn>
        <v-btn color="grey" @click="onCancel8" v-if="acceptBack == '8'">
          {{ $t("lang.common.back") }}
        </v-btn>
        <v-btn color="grey" @click="onCancel8001" v-if="acceptBack == '8001'">
          {{ $t("lang.common.back") }}
        </v-btn>
        <v-btn color="grey" @click="onCancel9" v-if="acceptBack == '9'">
          {{ $t("lang.common.back") }}
        </v-btn>
        <v-btn color="grey" @click="onCancel9001" v-if="acceptBack == '9001'">
          {{ $t("lang.common.back") }}
        </v-btn>
        <v-btn color="grey" @click="onCancel10001" v-if="acceptBack == '10001'">
          {{ $t("lang.common.back") }}
        </v-btn>
      </v-toolbar>
      <slot name="searchForm">
        <v-form @keyup.enter.native="onSearch" v-if="formType=='normal'">
          <v-layout wrap>
            <v-flex xs6 v-for="(item, key) in inputSearchItems" :key="key" style="padding:10px">
              <c-textbox :type="item.type" :icon="item.icon" :label="$t(item.label)"
                         v-model.trim="values[item.name]"
                         :placeholder="item.placeHolder" :autofocus="item.focus"></c-textbox>
            </v-flex>
          </v-layout>
        </v-form>
        <div style="text-align: center;" v-if="formType=='normal'">
          <v-btn color="primary" dark @click="onSearch">
            <v-icon dark left>search</v-icon>
            {{ $t('lang.common.search') }}
          </v-btn>
          <v-btn color="red" dark @click="createNew" v-if="acceptCreate == true">
            <v-icon dark left>add</v-icon>
            {{ $t('lang.common.add') }}
          </v-btn>
          <slot name="featureBtn">

          </slot>
        </div>
      </slot>
      <slot name="tableData">
        <v-data-table :items="items" :headers="fields" id="resultTable"
                      :total-items="totalRows"
                      :rows-per-page-items="rowsPerPageItems"
                      @update:pagination="onPaging"
                      :pagination.sync="pagination"
                      class="elevation-1 gru-table fixed-header"
        >
          <template slot="headers">
            <tr>
              <template v-for="(header, key) in fields">
                <th
                    :key="key"
                    v-if="header.hidden == undefined || header.hidden == false"
                    :width="header.width"
                    :class="[header.sortable?'column sortable active':'',(header.value == sortField && orderBy=='desc') ? 'desc' : 'asc']"
                    @click="changeSort(header)"
                >
                  <div v-if="header.value=='checkbox'" style="text-align: center">
                    <v-checkbox color="primary" hide-details v-model="selectAll"></v-checkbox>
                  </div>
                  <div v-else :style="header.headerStyle">
                    {{ $t(header.text) }}
                    <v-icon small class="no-print" v-if="header.sortable && header.value ==sortField">
                      arrow_upward
                    </v-icon>
                  </div>
                </th>
              </template>
            </tr>
            <tr v-if="formType=='intable'" class="grey lighten-3 no-print filter">
              <template v-for="(header, key) in fields">
                <td :key="key" v-if="header.hidden == undefined || header.hidden == false"
                    class="text-xs-left gru-filter">
                  <div v-if="header.search==true" class="border-and-box">
                    <div v-if="header.type=='select'">
                      <v-autocomplete
                          :placeholder="$t('lang.common.select_filter')"
                          single-line
                          hide-details
                          v-on:change="onChangeSelect($event, header.name)"
                          flat
                          small
                          clearable
                          browser-autocomplete="on"
                          v-model.trim="values[header.name]"
                          :items="defaultItems(header.items, header.itemText, header.itemValue)"
                          :item-text="header.itemText"
                          :item-value="header.itemValue"
                      ></v-autocomplete>
                    </div>
                    <div v-else-if="header.type=='date' && header.search == true" style="text-align: center">
                      <!--i-date-picker
                          formatter="DD/MM/YYYY"
                          v-model="values[header.value]"
                          label=""
                          :defaultValue="false"
                          @change="onSearch"
                          @clearText="clearText(header.value)"
                      /-->
                      <v-daterange
                          :placeholder="$t('lang.common.date_filter')"
                          single-line
                          hide-details
                          @input="catchChange(header)"
                          class="v-date-range-box v-text-field"
                          prepend-icon="place"
                          flat
                          small
                          v-model="values[header.value+'Src']"
                          locale="vi"
                          :preset-label="$t(header.text)"
                          display-format="DD/MM/YYYY"
                          separator-label="~"
                          :key="`${values[header.value+'Src'].start} ${values[header.value+'Src'].end}`"
                      ></v-daterange>
                    </div>
                    <div v-else-if="header.type=='datepicker' && header.search == true" style="text-align: center">
                      <i-date-picker
                          formatter="DD/MM/YYYY"
                          v-model="values[header.value]"
                          label=""
                          :defaultValue="false"
                          @change="onSearch"
                          @clearText="clearText(header.value)"
                      />
                    </div>
                    <div v-else>
                      <v-text-field single-line
                                    hide-details
                                    v-model.trim="values[header.value]"
                                    v-on:keyup.enter="onSearch"
                                    dense
                                    type="text"
                                    small
                      />
                    </div>

                  </div>
                  <v-icon v-else-if="header.value=='checkbox'">filter_list</v-icon>
                </td>
              </template>
            </tr>
          </template>
          <template slot="body.prepend">
          </template>
          <template slot="items" slot-scope="data">
            <template v-for="(header, key) in fields">
              <td :key="key" v-if="header.hidden == undefined || header.hidden == false" :width="header.width">
                <div v-if="header.type=='select'" :style="'min-width: 100px;padding: 12px;' + header.headerStyle">
                  <div v-if="header.items != undefined">
                    <div v-for="(s_item, index) in header.items"
                         v-bind:key="index">
                      <div v-if="s_item[header.itemValue] === data.item[header.name]
                      || (data.item[header.name] != undefined && s_item[header.itemValue] && data.item[header.name].toString() == s_item[header.itemValue].toString() )
                      || (data.item[header.name] != undefined && data.item[header.name].toString().endsWith(','+s_item[header.itemValue]))
                      || (data.item[header.name] != undefined && data.item[header.name].toString().startsWith(s_item[header.itemValue]+','))
                      || (data.item[header.name] != undefined && data.item[header.name].toString().indexOf(',' + s_item[header.itemValue]+',') != -1)
                      ">
                        <div>{{ s_item[header.itemText] }}</div>
                      </div>
                    </div>
                  </div>
                  <div v-else>
                    {{ $t(data.item[header.value]) }}
                  </div>
                </div>

                <div v-else-if="header.type=='upload'" style="text-align: center;min-width: 100px">
                  <i-upload name="attachId" inputType="nobutton"
                            v-model="data.item[header.value]" multifile=true
                            readonly="true"
                            fileType="normal"
                  />
                </div>


                <div v-else-if="header.value=='index'" style="text-align: center">
                  {{ pagination.rowsPerPage * (pagination.page - 1) + data.index + 1 }}
                </div>

                <div v-else-if="header.type=='progressbar'" style="text-align: center">
                  <div style="display: flex; align-items: center; justify-content: center;">
                    <v-progress-linear
                        :value="data.item[header.value]"
                        height="10"
                        color="blue"
                        style="width: 60%; margin-right: 8px"
                    />
                    <span>{{ data.item[header.value] }}</span>
                  </div>
                </div>
                <div v-else-if="header.type=='progressbar2'" style="text-align: center">
                  <div v-if="data.item[header.value] !== null" style="display: flex; align-items: center; justify-content: center;">
                    <v-progress-linear
                        :value="data.item[header.value]"
                        height="10"
                        color="blue"
                        style="width: 60%; margin-right: 8px"
                    />
                    <span>{{ data.item[header.value] }}%</span>
                  </div>
                </div>

                <div v-else-if="header.type=='rating'" style="text-align: center">
                  <div v-if="data.item[header.value] !== null" style="display: flex; align-items: center; justify-content: center;">
                    <v-rating
                        :value="data.item[header.value]"
                        color="amber"
                        background-color="grey lighten-2"
                        dense
                        half-increments
                        readonly
                    ></v-rating>
                  </div>
                </div>

                <div v-else-if="header.value=='checkbox'">
                  <v-checkbox v-model="data.item['check']" color="primary" hide-details></v-checkbox>
                </div>

                <div v-else-if="header.value=='custom_checkbox'" style="text-align: center;">
                  <v-checkbox
                      v-model="data.item['check']"
                      @change="onCheckBoxChange(header.event, $event, data.item)" ref="custom_checkbox"
                      :id="'custom_checkbox_' + key"
                      hide-details
                      class="align-center justify-center"
                  ></v-checkbox>
                  <!--                <v-checkbox-->
                  <!--                    :input-value="header.items.find(x => x[header.itemValue] === data.item[header.name]) ? true : false"-->
                  <!--                    @change="onCheckBoxChange(header.event, $event, data.item)"-->
                  <!--                    hide-details-->
                  <!--                    class="align-center justify-center"-->
                  <!--                ></v-checkbox>-->
                </div>

                <div v-else-if="header.value=='custom_action'" style="text-align: center;" :width="header.width">
                  <v-btn depressed outline icon fab dark :color="header.color" small
                         v-if="header.show == undefined || header.show == null || (header.show != null && header.show(data.item))"
                         @click="onCustomEvent(header.event,data.item)">
                    <v-icon>{{ header.icon }}</v-icon>
                  </v-btn>
                </div>

                <div v-else-if="header.value=='custom_action_list'"
                     style="text-align: center" :width="header.width">
                  <div v-if="header.items != undefined">
                    <v-btn depressed outline icon fab dark :color="s_item.color" small
                           v-for="(s_item, index) in header.items"
                           v-bind:key="index"
                           @click="onCustomEvent(s_item.event,data.item)"
                           v-if="shouldShowCustomButton(s_item.event, data.item)"
                    >
                      <v-icon>{{ s_item.icon }}</v-icon>
                    </v-btn>
                  </div>
                </div>

                <div v-else-if="header.value=='chekStatus'"
                     style="text-align: center" :width="header.width">
                  <div v-if="header.items != undefined">
                    <div v-if="data.item.status == 1">
                      <v-btn depressed outline icon fab dark color="red" small
                             v-for="(s_item, index) in header.items"
                             v-bind:key="index">
                        <v-icon>{{ s_item.icon }}</v-icon>
                      </v-btn>
                    </div>
                    <div v-if="data.item.status == 0">
                      <v-btn depressed outline icon fab dark :color="s_item.color" small
                             v-for="(s_item, index) in header.items"
                             v-bind:key="index"
                             @click="onCustomEventCheckStatus(s_item.event,data.item)">
                        <v-icon>{{ s_item.icon }}</v-icon>
                      </v-btn>
                    </div>
                  </div>
                </div>

                <div v-else-if="header.compound==undefined || header.compound ==false" style="padding: 12px">
                  <div v-if="header.render != undefined" :style="header.headerStyle">
                    {{ $t(header.render(data.item[header.value])) }}
                  </div>
                  <div v-if="header.renderItem != undefined" :style="header.headerStyle">
                    {{ $t(header.renderItem(data.item)) }}
                  </div>
                  <div v-else-if="header.dateFormat != undefined" :style="header.headerStyle">
                    {{ displayDate(data.item[header.value], header.dateFormat) }}
                  </div>
                  <div v-else-if="header.type == 'currency'" :style="header.headerStyle">
                    <div :style="header.contentStyle">{{ data.item[header.value] | currency }}</div>
                  </div>
                  <div v-else-if="header.type == 'link'" :style="header.headerStyle">
                    <div :style="header.contentStyle">
                      <a href="#" @click="gotoPage(header.event,data.item)">
                        {{ data.item[header.value] }}
                      </a>
                    </div>
                  </div>
                  <div v-else :style="header.contentStyle">
                    <a v-if="header.event != undefined && header.event != null" href="#"
                       @click="onCustomEvent(header.event,data.item)">
                      {{ $t(data.item[header.value]) }}
                    </a>
                    <label v-else>
                      <!--                    linhdx sua khi so 0 thi no hiện-->
                      {{ data.item[header.value] }}
                    </label>
                  </div>
                </div>

                <div v-else-if="header.value=='action'" style="text-align: center" :width="header.width">
                  <v-btn depressed outline icon fab dark color="primary" small @click="showLogModeClass(data)"
                         title="Xem log chuyển lớp"
                         v-if="acceptLogModeClass == true">
                    <v-icon>account_circle</v-icon>
                  </v-btn>
                  <v-btn depressed outline icon fab dark color="primary" small @click="babiShowLogModeClass(data)"
                         title="Xem log chuyển lớp"
                         v-if="babiAcceptLogModeClass == true">
                    <v-icon>account_circle</v-icon>
                  </v-btn>

                  <v-btn depressed outline icon fab dark color="primary" small @click="viewItem(data)"
                         title="view"
                         v-if="acceptView == true">
                    <v-icon>visibility</v-icon>
                  </v-btn>
                  <v-btn depressed outline icon fab dark color="primary" small @click="editItem(data)"
                         title="edit" v-if="acceptEdit == true">
                    <v-icon>edit</v-icon>
                  </v-btn>
                  <v-btn depressed outline icon fab dark color="pink" small @click="deleteItem(data)"
                         title="delete"
                         v-if="acceptDelete == true">
                    <v-icon>delete</v-icon>
                  </v-btn>
                  <v-btn depressed outline icon fab dark color="deep-purple" small @click="copyItem(data)"
                         title="copy"
                         v-if="acceptCopy == true">
                    <v-icon>file_copy</v-icon>
                  </v-btn>
                  <v-btn depressed outline icon fab dark color="primary" small @click="selectItem(data)"
                         title="select"
                         v-if="acceptSelect == true">
                    <v-icon>check</v-icon>
                  </v-btn>
                  <v-btn depressed outline icon fab dark color="primary" small @click="viewNotification(data)"
                         title="notification" v-if="acceptNotification == true">
                    <v-icon>notifications</v-icon>
                  </v-btn>
                </div>
                <slot v-else :name="header.value" :item="data.item"></slot>
              </td>
            </template>

          </template>
        </v-data-table>
      </slot>
    </v-card>
    <slot name="extra_component"/>
    <slot name="createForm">
      <c-create-form v-if="inputCreateItems.length > 0" :id="createDiv" :create-div="createDiv"
                     :search-div="searchDiv" :default-data="selectedItem"
                     :input-items="inputCreateItems" style="display: none" :create-url="createUrl"
                     :create-form-name="createForm" ref="createForm"/>
    </slot>

  </div>
</template>

<script>
import CTextbox from "./Textbox";
import CCreateForm from "./CreateForm";
import IUpload from "./Upload";
import IDatePicker from "./DatePicker";
//import {authHeader} from "../shared/auth-header";
import axios from "axios";
import VueController from "../../../public/js/controller";
import {message} from "@/shared/message";
import moment from 'moment';
import IDatepicker from "@/components/form/DatePicker";
import {VDaterange} from "vuetify-daterange-picker";

export default {
  name: 'c-search-form',
  components: {CCreateForm, CTextbox, IUpload, IDatePicker, VDaterange},
  inheritAttrs: true,
  props: {
    formName: {
      type: String,
      default: 'Manager'
    },
    createForm: {
      type: String,
      default: 'Create Form'
    },
    searchDiv: {
      type: String,
      default: 'searchDiv'
    },
    createDiv: {
      type: String,
      default: 'createDiv'
    },
    formType: {
      type: String,
      default: "normal",
    },
    buttons: {
      type: Array,
      default: () => []
    },
    inputSearchItems: {
      type: Array,
      default: () => []
    },
    inputCreateItems: {
      type: Array,
      default: () => []
    },
    searchUrl: {
      type: String,
      default: ""
    },
    createUrl: {
      type: String,
      default: ""
    },
    deleteUrl: {
      type: String,
      default: ""
    },
    deleteMultiUrl: {
      type: String,
      default: ""
    },
    fields: {
      type: [Array, Object],
      default: () => []
    },
    rowsPerPageItems: {
      type: [Array, Number],
      default: () => [100]
    },
    pageSize: {
      type: Number,
      default: 10
    },
    acceptCreate: {
      type: Boolean,
      default: true
    },
    acceptCreate2: {
      type: Boolean,
      default: false
    },
    acceptDelete: {
      type: Boolean,
      default: true
    },
    acceptClass: {
      type: String,
      default: null
    },
    acceptCopy: {
      type: Boolean,
      default: false
    },
    acceptView: {
      type: Boolean,
      default: false
    },
    acceptLogModeClass: {
      type: Boolean,
      default: false
    },
    babiAcceptLogModeClass: {
      type: Boolean,
      default: false
    },
    acceptBack: {
      type: String,
      default: 0
    },
    acceptExport: {
      type: String,
      default: 0
    },
    acceptEdit: {
      type: Boolean,
      default: true
    },
    acceptSelect: {
      type: Boolean,
      default: false
    },
    acceptNotification: {
      type: Boolean,
      default: false
    },
    keyProperty: {
      type: String,
      default: ""
    },
    displayToolbar: {
      type: Boolean,
      default: true,
    },
    customCreateNew: {
      type: Boolean,
      default: false
    },
    customEditItem: {
      type: Boolean,
      default: false
    },
    customClassItem: {
      type: Boolean,
      default: false
    },
    customCopyItem: {
      type: Boolean,
      default: false
    },
    customViewItem: {
      type: Boolean,
      default: false
    },
    reload: {
      type: Number,
      default: 0
    },
    resetSearch: {
      type: Boolean,
      default: true
    },
    isPagination: {
      type: Boolean,
      default: true
    },
    hiddenFields: {
      type: Object,
      default: () => ({})
    },
    lastSearchValues: {
      type: Object,
      default: () => ({})
    },
    deleteMulti: {
      type: Boolean,
      default: true
    },
    orderBy: {
      type: String,
      default: "asc"
    },
  },
  data: () => {
    return {
      values: {},
      items: [],
      model: {},
      searchDate: {},
      export: null,
      sortField: null,
      computedCondition: false,
      // orderBy: "asc",
      pagination: {
        rowsPerPage: 10,
        page: 1,
        totalItems: 0
      },
      selectedItem: {},
      currentPage: 1,
      totalRows: 0,
      selectAll: false
    }
  },
  created() {
    VueController.push(this);
    this.values = Object.assign({}, this.values, this.lastSearchValues);
    for (let i = 0; i < this.fields.length; i++) {
      if (this.fields[i].type == "date" && this.fields[i].search == true) {
        this.values[this.fields[i].value + 'Src'] = {};
      }
    }
  },
  destroyed() {
    VueController.removeComponentByEl(this);
  },

  computed: {
    lstModel: function () {
      return FormGenerator.lstModel;
    }
  },

  watch: {
    selectAll: function (value) {
      for (let i = 0; i < this.items.length; i++) {
        this.items[i]["check"] = value;
      }
    },
    searchUrl: function () {
      if (this.lastSearchValues === null || Object.keys(this.lastSearchValues).length === 0) {
        this.pagination.page = 1;
        this.values = {};
      }
      this.search();
    },

    hiddenFields: {
      handler(value) {
        // console.log(value);
        // linhdx remove key that have value -1
        // for (let i = 0; i < Object.keys(value).length; i++) {
        //   let key = Object.keys(value)[i];
        //   let val = value[key];
        //   if (val == -1) {
        //     delete value[key];
        //     delete this.values[key];
        //   }
        // }
        // this.values = Object.assign({}, this.values, value);
        this.search();
      },
      deep: true
    },

    lastSearchValues: {
      handler(value) {
        // linhdx remove key that have value -1
        for (let i = 0; i < Object.keys(value).length; i++) {
          let key = Object.keys(value)[i];
          let val = value[key];
          if (val == -1) {
            delete value[key];
            delete this.values[key];
          }
        }
        this.values = Object.assign({}, this.values, value);
        //alert(JSON.stringify(this.values));
        //this.search();
      },
      deep: true
    },
    reload: {
      handler(value) {
        /*        this.pagination.page=1;
                this.values = {};*/
        this.search();
      },
      deep: true
    },
    resetSearch: {
      handler(value) {
        if (value == false) {
          this.values = {};
          this.search();
        }

      },
      deep: true
    },
  },

  methods: {
    shouldShowCustomButton(event, item) {
      // Tùy theo tên event mà kiểm tra điều kiện cụ thể
      if (event === 'showReport') {
        return item.reportLink != null && item.reportLink !== '';
      }

      // Mặc định hiển thị với các nút khác
      return true;
    },
    showLogModeClass(data) {
      //this.$router.push({ path: '/importRequest' });
      console.log(data.item.accountId)
      this.$router.push({path: '/logModeAccountClass/view/' + data.item.accountId, query: this.$route.query});
    },
    babiShowLogModeClass(data) {
      console.log(data.item.accountId)
      this.$router.push({path: '/babiLogModeAccountClass/view/' + data.item.accountId, query: this.$route.query});
    },
    onCancel1() {
      this.$router.push({path: '/class/classAccountList', query: this.$route.query});
    },
    onCancel1001() {
      this.$router.push({path: '/babiClass/classAccountList', query: this.$route.query});
    },
    onCancel2() {
      //this.$router.push({ path: '/importRequest' });
      this.$router.push({path: '/programFrame/programlist', query: this.$route.query});
    },
    onCancel2001() {
      //this.$router.push({ path: '/importRequest' });
      this.$router.push({path: '/babiProgramFrame/programlist', query: this.$route.query});
    },
    onCancel3() {
      //this.$router.push({ path: '/importRequest' });
      this.$router.push({path: '/accountDetail/view/' + this.$route.params.id, query: this.$route.query});
    },
    onCancel3001() {
      this.$router.push({path: '/babiAccountDetail/view/' + this.$route.params.id, query: this.$route.query});
    },
    onCancel4() {
      this.$router.push({path: '/accountDetailClass/view/' + this.$route.params.id, query: this.$route.query});
    },
    onCancel4001() {
      this.$router.push({path: '/babiAccountDetailClass/view/' + this.$route.params.id, query: this.$route.query});
    },
    onCancel5() {
      this.$router.push({path: '/class/classlist', query: this.$route.query});
    },
    onCancel5001() {
      this.$router.push({path: '/babiClass/classlist', query: this.$route.query});
    },
    onCancel6() {
      this.$router.push({path: '/tracking', query: this.$route.query});
    },
    onCancel6001() {
      this.$router.push({path: '/babiTracking', query: this.$route.query});
    },
    onCancel7() {
      this.$router.go({path: '/account/accountList', query: this.$route.query});
    },
    onCancel7001() {
      this.$router.go({path: '/babiAccount/accountList', query: this.$route.query});
    },
    onCancel8() {
      this.$router.push({path: '/searchLogByPhone', query: this.$route.query});
    },
    onCancel9() {
      this.$router.push({path: '/account/accountList', query: this.$route.query});
    },
    onCancel9001() {
      this.$router.push({path: '/babiAccount/accountList', query: this.$route.query});
    },
    onCancel10() {
      this.$router.push({path: '/babiPro/classProList', query: this.$route.query});
    },
    catchChange(header) {
      this.values[header.fromDate] = this.values[header.value + "Src"].start;
      this.values[header.toDate] = this.values[header.value + "Src"].end;
      console.log(this.values);
      this.onSearch();
    },

    changeSort: function (header) {
      if (!header.sortable) {
        return;
      }
      if (this.sortField == header.value) {
        if (this.orderBy == "asc") {
          this.orderBy = "desc";
        } else {
          this.orderBy = "asc";
        }
      } else {
        this.sortField = header.value;
        this.orderBy = "desc";
      }
      this.onSearch();
    },

    onSearch: function () {
      //this.currentPage = 1;
      //alert(JSON.stringify(this.values))

      this.$emit("setLastSearchValues", this.values);
      //this.lastSearchValues = Object.assign({},this.lastSearchValues, this.values);
      this.pagination.page = 1;
      this.search();
    },

    onExport: function () {
      //this.currentPage = 1;
      //alert(JSON.stringify(this.values))

      this.$emit("setLastSearchValues", this.values);
      //this.lastSearchValues = Object.assign({},this.lastSearchValues, this.values);
      this.pagination.page = 1;
      this.exportAccount();
    },

    onChangeSelect(value = null, name = null) {
      this.hiddenFields[name] = value;
      this.$emit("formSelectChange", name, value);
      this.onSearch();
    },

    displayDate: function (data, format) {
      let dateStr = '';
      if (data != undefined) {
        let date_check = moment(data).format("YYYY-MM-DD");
        if (date_check != "Invalid date" && data.length > 0) {
          let dateDate = new Date(data);
          let month = dateDate.getMonth() + 1;
          if (month < 10) {
            month = "0" + month;
          }
          let year = dateDate.getFullYear();
          let date = dateDate.getDate();
          if (date < 10) {
            date = "0" + date;
          }
          let second = dateDate.getSeconds();
          let minute = dateDate.getMinutes();
          let hour = dateDate.getHours();
          dateStr = format.replace("dd", date).replace("MM", month).replace("yyyy", year).replace("mm", minute).replace("hh", hour).replace("ss", second);
        }
      }

      return dateStr;
    },

    exportAccount: function () {
      const hiddenFields = this.hiddenFields;
      if (hiddenFields != undefined && Object.keys(hiddenFields).length > 0) {
        for (let i = 0; i < Object.keys(hiddenFields).length; i++) {
          let key = Object.keys(hiddenFields)[i];
          let val = hiddenFields[key];
          if (val == -1) {
            delete hiddenFields[key];
            delete this.values[key];
          }
        }
        this.values = Object.assign({}, this.values, hiddenFields);
      }

      let connect = "?";
      if (this.searchUrl.charAt(this.searchUrl.length - 1) == "&") {
        connect = "";
      }

      let url = process.env.VUE_APP_API_URL + this.searchUrl + connect + "pageSize=" + this.pagination.rowsPerPage + "&page=" + this.pagination.page;
      if (!this.isPagination) {
        url = process.env.VUE_APP_API_URL + this.searchUrl + connect + "pageSize=-1&page=-1";
      }
      if (this.sortField != null && this.sortField != "") {
        url += "&sortField=" + this.sortField;
      }
      if (this.orderBy != null && this.orderBy != "") {
        url += "&orderBy=" + this.orderBy;
      }
      if (this.acceptExport == '11'){
        url += "&export=2";
      }else {
        url += "&export=1";
      }


      axios({
        url: url,
        method: "POST",
        data: this.values,
        responseType: "blob", // important
      }).then(response => {
        if (response) {
          const url = window.URL.createObjectURL(new Blob([response]));
          const link = document.createElement("a");
          link.href = url;

          if (this.acceptExport == '2') {
            link.setAttribute("download", "Result_Class" + ".xlsx");
          } else if (this.acceptExport == '3') {
            link.setAttribute("download", "Result_Tracking" + ".xlsx");
          } else if (this.acceptExport == '4') {
            link.setAttribute("download", "Result_OrderMath" + ".xlsx");
          } else if (this.acceptExport == '5') {
            link.setAttribute("download", "Result_ClassWeek" + ".xlsx");
          } else if (this.acceptExport == '6') {
            link.setAttribute("download", "Result_AccountPart" + ".xlsx");
          } else if (this.acceptExport == '7') {
            link.setAttribute("download", "Result_Kid_Mission_Review" + ".xlsx");
          } else if (this.acceptExport == '8') {
            link.setAttribute("download", "Result_Tracking_Mission" + ".xlsx");
          } else if (this.acceptExport == '9') {
            link.setAttribute("download", "Result_OrderLiveCassPackage" + ".xlsx");
          } else if (this.acceptExport == '10') {
            link.setAttribute("download", "Result_KidClassPro" + ".xlsx");
          }else if (this.acceptExport == '11') {
            link.setAttribute("download", "Result_KidTeacher_Schedule" + ".xlsx");
          } else {
            link.setAttribute("download", "Result_Account_Class" + ".xlsx");
          }

          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url);
        }
      });
    },

    search: function () {
      // console.log(this.values);
      // console.log(this.hiddenFields);
      //this.values = Object.assign({}, this.values, this.lastSearchValues);
      //let header = {headers:new authHeader()};
      // console.log(header);
      // alert(JSON.stringify(this.$refs.custom_checkbox))

      // hiddenFields
      const hiddenFields = this.hiddenFields;
      if (hiddenFields != undefined && Object.keys(hiddenFields).length > 0) {
        for (let i = 0; i < Object.keys(hiddenFields).length; i++) {
          let key = Object.keys(hiddenFields)[i];
          let val = hiddenFields[key];
          if (val == -1) {
            delete hiddenFields[key];
            delete this.values[key];
          }
        }
        this.values = Object.assign({}, this.values, hiddenFields);
      }

      this.selectAll = false;
      if (this.searchUrl == undefined || this.searchUrl == "") {
        this.items = [];
        this.totalRows = 0;
        return;
      }
      let connect = "?";
      if (this.searchUrl.charAt(this.searchUrl.length - 1) == "&") {
        connect = "";
      }

      let url = process.env.VUE_APP_API_URL + this.searchUrl + connect + "pageSize=" + this.pagination.rowsPerPage + "&page=" + this.pagination.page;
      if (!this.isPagination) {
        url = process.env.VUE_APP_API_URL + this.searchUrl + connect + "pageSize=-1&page=-1";
      }
      if (this.sortField != null && this.sortField != "") {
        url += "&sortField=" + this.sortField;
      }
      if (this.orderBy != null && this.orderBy != "") {
        url += "&orderBy=" + this.orderBy;
      }
      localStorage.setItem("pageMsg", this.pagination.page)

      if (this.$refs.custom_checkbox != undefined) {
        try {
          //linhdx set gia tri vao custom checkbox
          for (let i = 0; i < this.items.length; i++) {
            console.log(document.getElementById("custom_checkbox_" + i).check)
            document.getElementById("custom_checkbox_" + i).check = false;
          }
        } catch (e) {

        }
      }
      axios.post(url, this.values).then((data) => {

        //console.log("-after post get data");
        //console.log(data);
        if (data.items !== undefined) {
          //alert(JSON.stringify(data));
          this.items = data.items;
          this.totalRows = data.count;
        } else {
          this.items = data;
          this.totalRows = data.length;
        }
        if (this.$refs.custom_checkbox != undefined) {
          try {
            //linhdx set gia tri vao custom checkbox
            for (let i = 0; i < this.items.length; i++) {
              let item = this.items[i];
              item['check'] = false;
            }
            for (let i = 0; i < this.items.length; i++) {
              let item = this.items[i];
              for (let i = 0; i < this.fields.length; i++) {
                let header = this.fields[i];
                if (header.value == "custom_checkbox") {
                  if (header.items.find(x => x[header.itemValue] === item[header.name])) {
                    item['check'] = true;
                  }
                }
              }
            }
          } catch (e) {

          }
        }
        this.$emit("search");
      });
    },


    onPaging: function (page) {
      this.pagination = page;
      this.currentPage = page.page;
      this.search();
    },

    isEmpty: function (obj) {
      for (var key in obj) {
        if (obj.hasOwnProperty(key))
          return false;
      }
      return true;
    },

    createNew: function () {
      if (this.customCreateNew) {
        this.$emit("createNew");
      } else {
        this.showCreateForm({});
      }
    },

    editItem: function (data) {
      if (this.customEditItem) {
        this.$emit("editItem", data.item);
      } else {
        this.showCreateForm(data.item);
      }
    },

    classItem: function (data) {
      if (this.customClassItem) {
        this.$emit("classItem", data.item);
      } else {
        this.showCreateForm(data.item);
      }
    },

    selectItem: function (data) {
      this.$emit("selectItem", data.item);
    },

    viewNotification: function (data) {
      this.$emit("viewNotification", data.item);
    },

    copyItem: function (data) {
      if (this.customCopyItem) {
        this.$emit("copyItem", data.item);
      } else {
        data.item[this.keyProperty] = "";
        data.item["isCopy"] = true;
        this.showCreateForm(data.item);
      }
    },

    showCreateForm: function (item) {
      document.getElementById(this.searchDiv).style.display = "none";
      document.getElementById(this.createDiv).style.display = "";
      this.selectedItem = item;
      console.log(this.selectedItem);
      if (!this.isEmpty(this.$slots)) {
        if (this.$slots.createForm != undefined) {
          //console.log("here");
          let child = this.$slots.createForm[0].componentInstance;
          child.onView(item);
        }
      }
    },

    deleteItem: function (data) {
      if (confirm(this.$t("lang.common.deleteConfirm"))) {
        //let header = {headers:new authHeader()};
        axios.post(process.env.VUE_APP_API_URL + this.deleteUrl, data.item).then(data => {
          message.success(this.$t("lang.common.delete_success"));
          this.search();
        }, error => {
          message.error(this.$t("lang.common.deleteError"));
        });
      }
      ;
    },

    deleteItemList: function () {
      let deleteItems = [];
      for (let i = 0; i < this.items.length; i++) {
        if (this.items[i]['check']) {
          deleteItems.push(this.items[i]);
        }
      }
      console.log(deleteItems);
      if (deleteItems.length == 0) {
        message.error(this.$t("lang.common.select_one"));
        return;
      }
      if (confirm(this.$t("lang.common.deleteConfirm"))) {
        axios.post(process.env.VUE_APP_API_URL + this.deleteMultiUrl, deleteItems).then(data => {
          message.success(this.$t("lang.common.delete_success"));
          this.search();
        }, error => {
          message.error(this.$t("lang.common.deleteError"));
        });
      }
      ;
    },

    viewItem: function (data) {
      this.$emit("viewItem", data.item);
    },

    onButtonEvent(event) {
      let selectedItems = [];
      for (let i = 0; i < this.items.length; i++) {
        if (this.items[i]['check']) {
          selectedItems.push(this.items[i]);
        }
      }
      //console.log(deleteItems);
      // if (selectedItems.length == 0) {
      //   message.error(this.$t("lang.common.select_one"));
      //   return;
      // }
      if (event == undefined || event == null) {
        return;
      }
      this.$emit(event, selectedItems);

    },

    onCustomEventCheckStatus(event, data) {

      if (event == undefined || event == null) {
        return;
      }
      this.$emit(event, data);
      this.search();

    },

    onCustomEvent(event, data) {

      if (event == undefined || event == null) {
        return;
      }
      this.$emit(event, data);
    },

    gotoPage(event, data) {
      window.open(data.classLink, "_blank");
    },

    onCheckBoxChange(event, value, data) {
      if (event == undefined || event == null) {
        return;
      }
      this.$emit(event, value, data);
    },

    clearText: function (data) {
      this.values[data] = "";
      this.onSearch();
    },

    defaultItems(items, text, value) {
      // console.log(items);
      const items_tmp = [{[text]: 'Tất cả', [value]: ''}];
      // console.log(items_tmp);
      $.each(items, function (k, v) {
        items_tmp.push({[text]: v[text], [value]: v[value]});
      });
      // console.log(items_tmp);
      return items_tmp;
    },

    onClear(name) {
      this.values[name] = '';
      this.onSearch();
    },

  }
}
</script>
